import React from 'react'
import { useFukuanlxDelMutation } from '../../../store/DianShangYeWuApi'
import Icon from '../../../cpn/Icon';
import { App } from 'antd'
function CostTypeDel(props) {
    const {message} = App.useApp()
    const [submitDel] = useFukuanlxDelMutation()
    return (
        <Icon type='delete' 
            onClick={() => {
                submitDel({
                    fklx_id:props.fklx_id,
                }).then((res) => {
                    if (res.data.Status === 'success') {
                        message.info('删除成功');
                    }
                    if (res.data.Status === "fail") {
                        message.error('删除失败：'+res.data.Message)
                    }
                })
            }}
        > </Icon>
    )
    }

export default CostTypeDel